/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { config_GetFeatureConfigListResponse } from "../models/config_GetFeatureConfigListResponse"
import type { knowledgebase_ConnectAgentsRequest } from "../models/knowledgebase_ConnectAgentsRequest"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class MessagesAdminService {
    /**
     * Get connectable agents for messages
     * Get all available agents that can be connected to messages
     * @returns config_GetFeatureConfigListResponse OK
     * @throws ApiError
     */
    public static getV1AdminMessageConnectableAgents({
        agentType,
    }: {
        /** Filter by agent type **/
        agentType?: string
    }): CancelablePromise<config_GetFeatureConfigListResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v1/admin/message/connectable-agents",
            query: {
                agentType: agentType,
            },
            errors: {
                400: `Bad Request`,
            },
        })
    }

    /**
     * Set agent types for a message by ID
     * Set agent types for a message by ID (connects to shadow Knowledge Item)
     * @returns any OK
     * @throws ApiError
     */
    public static putV1AdminMessageConnectAgents({
        messageId,
        request,
    }: {
        /** Message ID **/
        messageId: number
        /** Request body to set agent types **/
        request: knowledgebase_ConnectAgentsRequest
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/v1/admin/message/{message_id}/connect-agents",
            path: {
                message_id: messageId,
            },
            body: request,
            errors: {
                400: `Bad Request`,
            },
        })
    }
}
